$(function () {
    if (typeof $.validator !== 'undefined') {
        $.validator.setDefaults({
            ignore: puritanLawn.validatorIgnoreQuillAndRecaptcha
        });
    }

    var $wysiwyg = document.getElementById('wysiwyg');
    var editor = puritanLawnJodit.create('#wysiwyg', '#wysiwyg', {
        initialHtml: ($wysiwyg && $wysiwyg.value) ? $wysiwyg.value : '',
        formSelector: '#pl-form',
        buttons: [
            'paragraph', '|',
            'bold', 'italic', 'underline', '|',
            'ul', 'ol', '|',
            'left', 'center', 'right', '|',
            'kygImageUpload', '|',
            'undo', 'redo'
        ],
        imageHandler: function () {
            $('#imageFileTMCE').trigger('click');
        }
    });

    var $importPanel = $('#pl-obituaryImportPanel');
    if ($importPanel.length) {
        $('#pl-importObituaryUrlButton').on('click', function () {
            var url = ($('#pl-obituaryImportUrl').val() || '').trim();
            var $msg = $('#pl-obituaryImportMessage');
            var $btn = $('#pl-importObituaryUrlButton');
            var $spin = $btn.find('.pl-importObituary-spinner');

            $msg.hide().removeClass('text-danger text-success text-warning').text('');

            if (!url) {
                $msg.addClass('text-danger').text('Enter a URL.').show();
                return;
            }

            var token = $('#pl-form input[name="__RequestVerificationToken"]').val();
            if (!token) {
                $msg.addClass('text-danger').text('Security token missing. Refresh the page and try again.').show();
                return;
            }

            $btn.prop('disabled', true);
            $spin.show();

            function normalizeImportResult(data) {
                if (!data || typeof data !== 'object') {
                    return { success: false, error: null, obituaryHtml: '', warnings: [], birthDate: null, deathDate: null };
                }
                return {
                    success: data.success === true || data.Success === true,
                    error: data.error || data.Error,
                    obituaryHtml: data.obituaryHtml || data.ObituaryHtml || '',
                    warnings: data.warnings || data.Warnings || [],
                    warningCodes: data.warningCodes || data.WarningCodes || [],
                    sourceType: data.sourceType || data.SourceType || '',
                    confidence: data.confidence != null ? data.confidence : data.Confidence,
                    signals: data.signals || data.Signals || [],
                    birthDate: data.birthDate != null ? data.birthDate : data.BirthDate,
                    deathDate: data.deathDate != null ? data.deathDate : data.DeathDate
                };
            }

            var importEndpoint = ($importPanel.data('import-url') || '').toString().trim() || '/Deceased/ImportObituaryFromUrl';

            $.ajax({
                url: importEndpoint,
                type: 'POST',
                // Do not use dataType: 'json': jQuery treats HTTP 200 + non-JSON body as failure ("parsererror"),
                // which shows as "Import failed (HTTP 200)" when the server returns HTML (e.g. login/expired session).
                dataType: 'text',
                headers: { 'Accept': 'application/json, text/plain, */*' },
                data: {
                    url: url,
                    __RequestVerificationToken: token
                }
            }).done(function (text) {
                var raw = (text == null ? '' : String(text)).replace(/^\uFEFF/, '').trim();
                if (!raw.length) {
                    $msg.addClass('text-danger').text('Empty response from the server. Refresh the page and try again.').show();
                    return;
                }
                if (raw.charAt(0) === '<') {
                    $msg.addClass('text-danger').text(
                        'Import did not return JSON (got an HTML page—often sign-in or an error). Refresh, sign in if needed, and try again.'
                    ).show();
                    return;
                }
                var data;
                try {
                    data = JSON.parse(raw);
                } catch (parseErr) {
                    $msg.addClass('text-danger').text('Could not read the server response. Refresh the page and try again.').show();
                    return;
                }

                var r = normalizeImportResult(data);
                if (!r.success) {
                    $msg.addClass('text-danger').text(r.error || 'Import failed.').show();
                    return;
                }

                if (editor && editor.jodit) {
                    editor.jodit.value = r.obituaryHtml;
                }
                puritanLawnJodit.sync(editor, document.getElementById('wysiwyg'));

                var parts = [];
                if (r.warnings && r.warnings.length) {
                    parts = parts.concat(r.warnings);
                }
                if (!parts.length) {
                    parts.push('Imported. Review the obituary text below before submitting.');
                }
                if (r.sourceType) {
                    parts.push('Source: ' + r.sourceType + (r.confidence != null ? ' (confidence ' + r.confidence + '%)' : ''));
                }
                if (r.warningCodes && r.warningCodes.length) {
                    parts.push('Flags: ' + r.warningCodes.join(', '));
                }
                $msg.addClass('text-success').html(parts.join('<br/>')).show();

                applyImportedDates(r);
            }).fail(function (xhr, textStatus) {
                var err = 'Request failed (HTTP ' + (xhr.status || '?') + ').';
                if (xhr.status === 0) {
                    err = 'Network error. Check your connection and try again.';
                } else if (xhr.status === 403) {
                    err = 'You do not have permission to use this feature.';
                } else if (xhr.status === 400) {
                    err = 'Request was rejected (often an expired security token). Refresh the page and try again.';
                } else if (xhr.status === 200 && textStatus === 'parsererror') {
                    err = 'The server response was not valid JSON. Refresh the page and try again.';
                }
                try {
                    var j = xhr.responseJSON;
                    if (!j && xhr.responseText) {
                        var t = xhr.responseText.replace(/^\uFEFF/, '').trim();
                        if (t.charAt(0) === '{') {
                            j = JSON.parse(t);
                        }
                    }
                    if (j && (j.error || j.Error)) {
                        err = j.error || j.Error;
                    }
                } catch (ignore) { }
                $msg.addClass('text-danger').text(err).show();
            }).always(function () {
                $btn.prop('disabled', false);
                $spin.hide();
            });
        });
    }

    function toDateInputValue(iso) {
        if (!iso) {
            return null;
        }
        var d = new Date(iso);
        if (isNaN(d.getTime())) {
            return null;
        }
        var y = d.getUTCFullYear();
        var m = d.getUTCMonth() + 1;
        var day = d.getUTCDate();
        return y + '-' + (m < 10 ? '0' : '') + m + '-' + (day < 10 ? '0' : '') + day;
    }

    function applyImportedDates(data) {
        var birthVal = toDateInputValue(data.birthDate);
        var deathVal = toDateInputValue(data.deathDate);
        if (!birthVal && !deathVal) {
            return;
        }

        var $b = $('#pl-remembranceBirthDate');
        var $d = $('#pl-remembranceDeathDate');
        var hasBirth = $b.length && $b.val();
        var hasDeath = $d.length && $d.val();
        var needConfirm = (birthVal && hasBirth) || (deathVal && hasDeath);

        function setDates() {
            if (birthVal && $b.length) {
                $b.val(birthVal);
            }
            if (deathVal && $d.length) {
                $d.val(deathVal);
            }
        }

        if (needConfirm) {
            puritanLawn.showTwoButtonModal(
                'Replace dates?',
                'The imported page includes birth or death dates. Replace the dates already on this form?',
                'Yes, replace',
                setDates,
                'No, keep current dates',
                function () { }
            );
        } else {
            setDates();
        }
    }

    $('#imageFileTMCE').on('change', function () {
        var files = this.files;
        if (!files || !files.length) {
            return;
        }
        var formData = new FormData();
        formData.append('Files', files[0]);
        formData.append('fileType', puritanLawn.fileType.DynamicContentImage);

        puritanLawn.ajaxPostMultiPartFormData(puritanLawn.adminServicesBaseAddress + 'UploadFiles',
            formData,
            function (results) {
                puritanLawnJodit.insertImageUrl(editor, results[0].url);
                $('#imageFileTMCE').val('');
            },
            function () {
                alert('error');
            }
        );
    });

    $('#pl-form-submitButton').on('click', function () {
        puritanLawnJodit.sync(editor, document.getElementById('wysiwyg'));
    });

    $('#updateProfileImageButton').on('click', function () {
        puritanLawn.viewModel.galleryImageIndex = null;
        $('#imageFile').trigger('click');
    });

    $('#imageFile').on('change', function () {
        var files = this.files;
        var formData = new FormData();

        formData.append('deceasedId', puritanLawn.viewModel.deceasedId);

        for (var i = 0; i < files.length; i++) {
            formData.append('Files', files[i]);
        }

        formData.append('fileType', puritanLawn.fileType.DeceasedProfileImage);

        puritanLawn.ajaxPostMultiPartFormData(puritanLawn.adminServicesBaseAddress + 'UploadFiles',
            formData,
            function (results) {
                var result = results[0];

                if (puritanLawn.viewModel.galleryImageIndex == null) {
                    $('#profileImage').attr('src', result.url);
                    $('#imageFileName').val(result.name);
                }
                else {
                    var deceasedImages = puritanLawn.viewModel.deceasedImages;
                    var deceasedImage;

                    if (puritanLawn.viewModel.galleryImageIndex == 'new') {
                        deceasedImage = {};
                        deceasedImages.push(deceasedImage);
                    }
                    else {
                        deceasedImage = deceasedImages[puritanLawn.viewModel.galleryImageIndex];
                    }

                    deceasedImage.fileName = result.name;
                    deceasedImage.url = result.url;

                    renderImageGallery();
                }
            },
            function () {
                alert('error');
            }
        );
    });

    renderImageGallery();
});

function initViewModel(model) {
    var viewModel = {
        deceasedId: model.deceasedId,
        deceasedImagePathRoot: model.deceasedImagePathRoot,
        grc: null,
        onCancel: function () {
            puritanLawn.showTwoButtonModal('Cancel Submission',
                'Are you sure you want to cancel your changes?',
                'Yes',
                function () {
                    window.location.href = '/Deceased/Index/' + model.deceasedId;
                },
                'No');
        },
        onSubmit: function () {
            var recaptchaCompleted = false;

            if (puritanLawn.viewModel && puritanLawn.viewModel.grc !== null) {
                recaptchaCompleted = puritanLawn.viewModel.grc;
            } else if (window.recaptchaComplete !== undefined) {
                recaptchaCompleted = window.recaptchaComplete;
            }

            if (!recaptchaCompleted) {
                puritanLawn.showOneButtonModal('Security Check',
                    'Please confirm you are not a robot before submitting.',
                    'OK');
                return;
            }

            puritanLawn.showTwoButtonModal('Confirm Submission',
                'Are you sure you want to submit your changes to this remembrance?',
                'Yes',
                function () {
                    var deceasedImageFileNames = _.pluck(puritanLawn.viewModel.deceasedImages, 'fileName').join('|');
                    var deceasedImageDescriptions = _.pluck(puritanLawn.viewModel.deceasedImages, 'description').join('|');

                    $('#DeceasedImageFileNames').val(deceasedImageFileNames);
                    $('#DeceasedImageDescriptions').val(deceasedImageDescriptions);
                    $('#pl-form-cancelButton').prop('disabled', true);
                    $('#pl-form-submitButton').prop('disabled', true);
                    $('#pl-form-submitButton span:first-of-type').show();
                    $('#pl-form').submit();
                },
                'No');
        },
        deceasedImages: [],
        galleryImageIndex: null
    };

    if (window.recaptchaComplete) {
        viewModel.grc = window.recaptchaComplete;
    }

    for (var i in model.data.DeceasedImages) {
        var deceasedImage = model.data.DeceasedImages[i];

        viewModel.deceasedImages[i] = {
            id: deceasedImage.id,
            fileName: deceasedImage.FileName,
            url: viewModel.deceasedImagePathRoot + deceasedImage.FileName,
            description: deceasedImage.Description,
            submitter: puritanLawn.submitterForDisplay(deceasedImage.SubmittedByUserFullName, 'Unknown', deceasedImage.DateSubmitted)
        };
    }

    return viewModel;
}

function renderImageGallery() {
    var source = document.getElementById('imageGalleryTemplate').innerHTML;
    var template = Handlebars.compile(source);
    var html = template(puritanLawn.viewModel);

    detachImageElements();

    $('#imageGallery').html(html);

    attachImageElements();
}

function attachImageElements() {
    $('.addGalleryImageButton').on('click', addGalleryImage);
    $('.galleryImageDescriptionInput').on('blur', updateGalleryImageDescription);
    $('.updateGalleryImageButton').on('click', updateGalleryImage);
    $('.removeGalleryImageButton').on('click', removeGalleryImage);
}

function detachImageElements() {
    $('.addGalleryImageButton').off('click', addGalleryImage);
    $('.galleryImageDescriptionInput').off('blur', updateGalleryImageDescription);
    $('.updateGalleryImageButton').off('click', updateGalleryImage);
    $('.removeGalleryImageButton').off('click', removeGalleryImage);
}

function updateGalleryImageDescription(e) {
    var index = $(this).attr('data-pl-index');
    var deceasedImage = puritanLawn.viewModel.deceasedImages[index];

    deceasedImage.description = $(this).val();

    e.preventDefault();
}

function addGalleryImage(e) {
    puritanLawn.viewModel.galleryImageIndex = 'new';
    $('#imageFile').trigger('click');
    e.preventDefault();
}

function updateGalleryImage(e) {
    var index = $(this).attr('data-pl-index');
    puritanLawn.viewModel.galleryImageIndex = index;
    $('#imageFile').trigger('click');
    e.preventDefault();
}

function removeGalleryImage(e) {
    var index = $(this).attr('data-pl-index');
    puritanLawn.viewModel.deceasedImages = _.without(puritanLawn.viewModel.deceasedImages, puritanLawn.viewModel.deceasedImages[index]);
    e.preventDefault();

    renderImageGallery();
}
